<template>
  <v-row>
    <v-col>
      <v-text-field
        label="Tågnummer"
        type="number"
        hide-details
        outlined
        @keydown.enter.prevent="searchConfirm"
        v-model="train_number"
        :disabled="readonly"
      />
      <!-- <v-combobox
        outlined
        type="number"
        v-model="model"
        hide-selected
        label="Tågnummer"
        multiple
        small-chips
        :disabled="readonly"
      >
        <template v-slot:selection="{ item }">
          <v-chip small hide-details>
            {{ item }}
            <v-icon v-if="!readonly" small right @click="removeItem(item)">
              mdi-close-circle
            </v-icon>
          </v-chip>
        </template>
      </v-combobox> -->
    </v-col>
    <v-col cols="3">
      <v-btn
        :disabled="!train_number || !train_number.length"
        depressed
        large
        @click="searchConfirm"
        rounded
        :loading="pending"
      >
        <v-icon small left>mdi-magnify</v-icon>
        Sök
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { sync, get } from 'vuex-pathify'
import { format } from 'date-fns'
import SEARCH_DUWA_QUERY from '../../graphql/searchDuwa'

export default {
  name: 'OdocTrainNumberInput',

  props: {
    readonly: Boolean
  },

  data() {
    return {
      train_number: '',
      pending: false
    }
  },

  computed: {
    model: sync('odoc/model@tur'),
    eventRoutes: get('odoc/model@sammanfattning'),
    eventDate: get('odoc/model@event_date')
  },

  created() {
    if (this.model && this.model.length) {
      this.train_number = this.model[0]
    }
  },

  watch: {
    train_number: {
      handler(value) {
        if (!value || !value.length) {
          this.$store.set('odoc/model@tur', [])
        } else {
          this.$store.set('odoc/model@tur', [value])
        }
      }
    }
  },

  methods: {
    removeItem(item) {
      const index = this.model.findIndex(x => x === item)
      if (index >= 0) this.model.splice(index, 1)
      this.$store.set('odoc/model@tur', this.model)
    },

    async searchConfirm() {
      if (!this.model) {
        return
      }
      this.pending = true
      const { data } = await this.$apollo.query({
        query: SEARCH_DUWA_QUERY,
        variables: {
          filter: {
            train_number: this.train_number,
            departure_date: format(new Date(this.eventDate), 'yyyy-MM-dd')
          }
        },
        fetchPolicy: 'no-cache'
      })
      if (data.searchDuwa && data.searchDuwa.announcements) {
        const firstPlace = data.searchDuwa.announcements[0]
        const lastPlace =
          data.searchDuwa.announcements[
            data.searchDuwa.announcements.length - 1
          ]
        if (this.model.length === 1) {
          const eventDate = format(new Date(this.eventDate), 'yyyy-MM-dd')
          const firstPlaceTime = format(
            new Date(firstPlace.advertised_time_at_location),
            'HH:mm'
          )
          const timeStart = new Date(`${eventDate} ${firstPlaceTime}`)
          this.$store.set('odoc/model@event_date', timeStart)
        }
        const route = `${firstPlace.location_signature.toUpperCase()}-${lastPlace.location_signature.toUpperCase()}`
        const routes = [route]
        this.$store.set('odoc/model@sammanfattning', routes)
      }
      this.pending = false
    }
  }
}
</script>
